import { MOSTRAR_LOADING } from '../types'

export default function mostrarLoading () {
  return {
    type: MOSTRAR_LOADING,
    payload: null
  }
}
